import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal';
import ImageCropper from './ImageCropper';

class ImageCropperModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      imageCropped: false,
      closeModal: false,
    };
  }

  componentWillUnmount() {
    this.props.onImageCropperClosed();
  }

  render() {
    if (this.state.error) {
      return (
        <div className={`image-cropper-modal ${this.props.className}`}>
          <Modal
            closeModal={this.state.closeModal}
            onModalClose={this.onModalClosed.bind(this)}
          >
            { this.state.error &&
              <span className="image-cropper__error">
                {this.state.error}
              </span>
            }
          </Modal>
        </div>
      );
    }

    return (
      <div className={`image-cropper-modal ${this.props.className}`}>
        <Modal
          closeModal={this.state.closeModal}
          onModalClose={this.onModalClosed.bind(this)}
        >
          <div className="image-cropper__content">
            <ImageCropper
              imageData={this.props.imageData}
              minBoundingSize={this.props.minBoundingSize}
              onBoundingBoxChange={this.onBoundingBoxChange.bind(this)}
              onImageLoadError={this.onImageLoadError.bind(this)}
            />
          </div>

          <button
            className="button button--gradient upload-button"
            onClick={this.closeModal.bind(this)}
          >
            {this.props.buttonLabel}
          </button>
        </Modal>
      </div>
    );
  }

  closeModal() {
    this.setState({
      imageCropped: true,
      closeModal: true
    });
  }

  onBoundingBoxChange(boundingBox) {
    this.props.onBoundingBoxChange(boundingBox);
  }

  onImageLoadError(error) {
    this.setState({ error });
  }

  onModalClosed() {
    this.props.onImageCropperClosed(this.state.imageCropped);
  }
}

ImageCropperModal.defaultProps = {
  className: '',
  buttonLabel: 'Done',
  minBoundingSize: 300
};

ImageCropperModal.propTypes = {
  className: PropTypes.string,
  buttonLabel: PropTypes.string,
  imageData: PropTypes.any,
  onImageCropperClosed: PropTypes.func.isRequired,
  onBoundingBoxChange: PropTypes.func,
  minBoundingSize: PropTypes.number
};

export default ImageCropperModal;
